import React from "react";
import { Box } from "@mui/material";
import { InputLabel } from "../../../components";
import { StyledBoxStack } from "./styles";

const required = true;

export const items = [
  {
    id: "size",
    label: "Size",
    required,
  },
  {
    id: "height",
    label: "Height",
    required,
  },
  {
    id: "quantity",
    label: "Quantity",
    required,
  },
  {
    id: "weight",
    label: "Weight",
    required,
  },
  {
    id: "x",
    label: "",
  },
];

export const ShipmentBoxesTableHeader = ({}) => {
  return (
    <StyledBoxStack
      sx={{
        backgroundColor: "hubColors.greyLighter",
        borderTop: "1px solid",
        borderColor: "hubColors.greyLight",
      }}
    >
      {items?.map((cell, idx) => (
        <Box
          key={idx}
          sx={{
            borderRight: "1px solid",
            borderColor: "hubColors.greyLight",
            padding: "4px 5px",
            height: "100%",
          }}
        >
          <InputLabel
            key={cell.id}
            label={cell.label}
            required={cell.required}
            marginLeft="5px"
            marginBottom="0px"
            sx={{
              textWrap: "nowrap",
            }}
          />
        </Box>
      ))}
    </StyledBoxStack>
  );
};

export default ShipmentBoxesTableHeader;
